import React from 'react';
import PropTypes from 'prop-types';

import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as vignetsActions from "../../actions/vignets";
import VignetContainer from "../vignets/VignetContainer";
import 'react-confirm-alert/src/react-confirm-alert.css'
import * as playlistActions from "../../actions/playlist";
import * as uploadActions from "../../actions/upload";
import {Modal, ModalBody, ModalFooter, Button} from 'reactstrap';
import ReactImageFallback from "react-image-fallback";
import AutoComplete from "../includes/AutoComplete";
import * as userActions from "../../actions/user";
import AuthService from "../../lib/AuthService";
class RightContentHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vignetIds: [],
            showDialog: false,
            showError : false,
            modalOptions : { showHeader : false, showFooter : false , titlepageSettings  : '', id : "galleryModal", content: '' },
            showPl : false,
            showConfirm : false,
            showConfirmLive : false,
            showPlMessage : false,
            addVigToPl : false,
            vignet_name: '',
            vignet_tags: '',
            vignet_desc :'',
            titleError  : '',
            image_path: null,
            showMoveVignets : false,
            selectedUser: [],
            username: ''

        };
        this.Auth = new AuthService();
        this.renderPageTitle = this.renderPageTitle.bind(this);
        this.plToggle = this.plToggle.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.toggle = this.toggle.bind(this);
        this.vToggle = this.vToggle.bind(this);
        this.liveToggle = this.liveToggle.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.setAsLive = this.setAsLive.bind(this);
        this.moveVignets = this.moveVignets.bind(this);
        this.getslctedusers = this.getslctedusers.bind(this);
        this.confirmVignetsmove = this.confirmVignetsmove.bind(this);
    }

    componentDidMount() {

        if( this.props.match.path === "/playlist/add/:id") {
            this.setState({ addVigToPl: true});
        }

        let data = {loginid :  this.Auth.getProfile().user_id};
        this.props.userSelectedData(data);
    }

    deleteItems() {

        if(this.props.vignetsData.selected_ids.length > 0) {
            this.setState({ showConfirm : true, modalOptions : {showModal:this.state.showModal} });

        }
        else {
            this.setState({showPlMessage : true});
        }
    }

    confirmLive() {
        this.setState({showConfirmLive : true});
    }

    setAsLive() {
        this.props.setAsLive(this.props.vignetsData.selected_ids);
        this.setState({ showConfirmLive :false });
    }

    joinVignets() {
        this.props.modalToggle({modalOpen : true, modalTitle : "Merge Nuggeta", "modalType" : "merge-vig"});

    }

    showMyPlaylists(e) {

        if(this.props.vignetsData.selected_ids.length > 0) {

            if(this.props.pageName === 'VIGNETS') {
                this.setState({ showPl : true, modalOptions : {showModal:this.state.showModal} });
            }
        }
        else {
            this.setState({showPlMessage : true});
        }

    }

    addToPlaylist(plid) {
        let data = {plid : plid, vigids : this.props.vignetsData.selected_ids}
        let added = this.props.addItemToPlaylist(data);

        if(added){
            this.plToggle();
        }


        // $("#plModal").({'data-dismiss': 'modal'});
    }

    renderPageTitle() {
        let vignet = this.props.vignetsData && this.props.vignetsData.vignetDetail ? this.props.vignetsData.vignetDetail : '';
        switch(this.props.pageName) {
            case 'OVERVIEW':
                return 'Overview';
            case 'VIGNETS':
                return 'Nuggets';
            case 'VIGDETAIL':
                return vignet.vignet_title;
            case 'MY_UPLOADS':
                return 'Gallery';
            case 'AUDIO':
                return 'Audio';
            case 'VIDEO':
                return 'Video';
            case 'PLAYLIST':
                return 'Playlist';
            case 'PLAYLISTDETAIL':
                return 'Playlist';
            case 'USER':
                return 'User';
            default:
                return 'Vignets';
        }
    }

    renderItemCount() {

        switch(this.props.pageName) {
            case 'VIGNETS':
                return this.props.vignetsData.vignetCount;
            case 'MY_UPLOADS':
                return this.props.galleryData.galleryCount;
            case 'AUDIO':
                return this.props.galleryData.galleryCount;
            case 'VIDEO':
                return this.props.galleryData.galleryCount;
            case 'PLAYLIST':
                return this.props.playlistData.playlistCount;
            case 'USER':
                return this.props.userListData.userListCount;
            default:
                return this.props.vignetsData.vignetCount;
        }
    }

    plToggle() {
        console.log(this.state.showPl);
        this.setState({
            showPl: !this.state.showPl
        });
    }

    confirmDelete() {
        let data = {vigids : this.props.vignetsData.selected_ids, userid : this.Auth.getProfile().user_id };
        this.props.removeVignets(data);
        this.setState({ showConfirm :false });
    }

    toggle() {
        this.setState({
            showConfirm: !this.state.showConfirm
        });
    }
    mToggle() {
        console.log(this.state.showPlMessage);
        this.setState({
            showPlMessage: !this.state.showPlMessage
        });
    }
    liveToggle() {
        this.setState({
            showConfirmLive: !this.state.showConfirmLive
        });
    }
    moveVignets(){

        this.setState({
            showMoveVignets: !this.state.showMoveVignets
        });
    }
    backToPlaylists() {
        this.props.backToPlaylists();
    }

    vToggle() {
        this.setState({
            modal: !this.state.modal,
            image_path: null,
            vignet_name : '',
            vignet_desc : '',
            vignet_tag : '',
            titleError : ''
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        console.log(this.state.image_path+"========= thi.state.iamgepath");
        //Request to purging
        this.props.getImagepurged({image_name : 'cf'+this.state.vignet_id, image_path : fileName});

    }
    resultDataList( result, reference, valueField) {

        let uniqueIds = result.map(item => item[valueField]);
        this.setState({ [reference] : result , selctduser : uniqueIds[0] });
        this.props.userSelectedData(reference, uniqueIds);

    }
    getslctedusers(searchText='') {
        let data = {loginid :  this.Auth.getProfile().user_id, username : searchText };
        this.props.userSelectedData(data);
    }
    confirmVignetsmove(){

        let data = {'vignet_id' : this.props.vignetsData.selected_ids, 'user_id' :  this.Auth.getProfile().user_id, 'chnguser_id' : this.state.selctduser };
        this.props.changeUserVignet(data);
        this.setState({ showMoveVignets :false });
    }

    render() {
        let img_name = '';
        let vignet = this.props.vignetsData && this.props.vignetsData.vignetDetail ? this.props.vignetsData.vignetDetail : '';
        if(vignet ) {
            console.log(vignet.vignet_id)
            img_name = vignet.vignet_id;
        }
        let ImgSrc = this.props.pageSettingsData.config.BUCKET_PATH+'assets/slider/cf'+img_name+'.jpg';
        let defImgSrc = '/assets/images/no-gallery.jpg';


        return (

            <div className="right-top-header">
                <div className="right-top-header-wrap">
                    <div className= {this.props.pageName === 'VIGDETAIL'? "page-title with-image":"page-title"}>
                        {this.props.pageName === 'VIGDETAIL' &&
                        <div className="header-thumb">
                            {/*<img src={ImgSrc} alt="User" />*/}
                            <ReactImageFallback
                                src={ImgSrc}
                                fallbackImage={defImgSrc}
                                initialImage={defImgSrc}
                                alt=""
                                className="my-image" />
                        </div>
                        }
                        <h1 className="subheader">{this.renderPageTitle()} {this.props.pageName !== 'VIGDETAIL' &&  this.props.pageName !== 'OVERVIEW' && this.props.pageName !== 'PLAYLISTDETAIL' &&  '('+this.renderItemCount()+')'}</h1>
                    </div>

                    {!this.state.addVigToPl  &&
                    <div className="header-option-block">
                        {this.props.pageName === 'VIGNETS' && this.props.vignetsData.selected_ids.length > 0 &&
                        <ul className="header-option-list">

                            <li>
                                <nav className="header-option icon-lib delete-ico"
                                     data-toggle="modal" data-target="#delete-vignets"
                                     onClick={() => {
                                         this.deleteItems()
                                     }}>Delete</nav>
                            </li>
                            <li>
                                <nav className="header-option icon-lib live-ico"
                                     data-toggle="modal" data-target="#live-vignets"
                                     onClick={() => {
                                         this.confirmLive()
                                     }}>Mark as Live</nav>
                            </li>
                            <li>
                                <nav className="header-option icon-lib live-ico"
                                     data-toggle="modal" data-target="#move-vignets"
                                     onClick={() => {
                                         this.moveVignets()
                                     }}>Move Nuggets</nav>
                            </li>
                            {this.props.vignetsData.selected_ids.length > 1 &&
                            <li>
                                <a href="javascript:void(0);" className="header-option  join-ico"
                                   onClick={() => {
                                       this.joinVignets()
                                   }}>Join</a>
                            </li>
                            }

                        </ul>
                        }
                        {this.props.pageName === 'PLAYLISTDETAIL' &&
                        <button type="button" className="btn btn-secondary"
                                onClick={() => this.backToPlaylists()}>Back To Playlists</button>
                        }
                    </div>
                    }


                </div>
                {/*
                    this.state.showDialog &&
                    <ReactConfirmAlert
                        title="Confirm "
                        message="Are you sure to delete the vignets?"
                        confirmLabel="Confirm"
                        cancelLabel="Cancel"
                        onConfirm={() => this.confirmDelete()}
                        onCancel={() => alert('Action after Cancel')}
                    />
                */}

                {this.state.showConfirm &&

                <Modal isOpen={this.state.showConfirm} id="delete-vignets">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to delete the nuggets?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                        <Button color="primary" onClick={this.confirmDelete}>Confirm</Button>
                    </ModalFooter>
                </Modal>
                }

                {this.state.showPlMessage &&

                <Modal isOpen={this.state.showPlMessage} id="pl-message">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            No nuggets have been selected
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.mToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }
                {this.state.showConfirmLive &&

                <Modal isOpen={this.state.showConfirmLive} id="live-vignets">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to mark the nuggets as Live?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.liveToggle}>Cancel</Button>
                        <Button color="primary" onClick={this.setAsLive}>Confirm</Button>
                    </ModalFooter>
                </Modal>
                }
                {this.state.showMoveVignets &&

            <Modal isOpen={this.state.showMoveVignets} id="live-vignets">
                <ModalBody>
                             <AutoComplete
                                fieldTitle = ''
                                placeholder={'Username'}
                                sourceDataList = {this.props.userData.searchSelectduser}
                                searchField = 'name'
                                showIcon={true}
                                showSubLabel = {true}
                                labelFields = 'name'
                                valueField ='user_id'
                                showProfile = {true}
                                reference='selectedUser'
                                selectedItems = {this.state.selectedUser}
                                resultDataList = {this.resultDataList.bind(this)}
                                id="to_users"
                                instantSearch = {true}
                                actionMethod = {this.getslctedusers}
                            />

                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.moveVignets}>Cancel</Button>
                    <Button color="primary" onClick={this.confirmVignetsmove}>Confirm</Button>
                </ModalFooter>
            </Modal>
            }



            </div>

        );
    }
}


RightContentHeader.propTypes = {
    pageName: PropTypes.string
}



function mapStateToProps(state) {
    return {
        userData  :state.user.userListData,
        vignetsData  :state.vignets.vignetsData,
        galleryData  :state.gallery.galleryData,
        playlistData  :state.playlist.playlistData,
        userListData  :state.user.userListData,
        uploadData : state.upload.uploadData,
        pageSettingsData  : state.pages.pageSettings
    };

}

export default  withRouter(connect(mapStateToProps, {
    selectedVignets : vignetsActions.vignetsSelected,
    removeVignets : vignetsActions.deleteVignets,
    addItemToPlaylist : playlistActions.addToPlaylist,
    allPlaylistData : playlistActions.getPlayLists,
    removeSelection : vignetsActions.removeSelection,
    backToPlaylists : playlistActions.resetPlaylistDetail,
    uploadErrors: uploadActions.uploadErrors,
    modalToggle : vignetsActions.toggleModal,
    setAsLive : vignetsActions.setAsLive,
    userSelectedData : userActions.selectedUser,
    changeUserVignet : vignetsActions.saveNewVignetUser,
})(RightContentHeader, VignetContainer));



// WEBPACK FOOTER //
// ./src/components/common/RightContentHeader.js